<app-module-header
  [title]="organization.organizationName + ' - ' + ('VEHICLE_MANAGEMENT.TITLE' | transloco)"
  [icon]="'directions_car'"
></app-module-header>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate" class="mb-2"></mat-progress-bar>
}

<div class="">
  <div class="header">
    <!-- <h2>Parking Locations</h2> -->
    <button mat-stroked-button class="mt-2 mb-3" color="primary" (click)="editVehicle(null)">
      <mat-icon>add</mat-icon> {{ 'VEHICLE_MANAGEMENT.ADD_VEHICLE' | transloco }}
    </button>
  </div>

  <div class="filter-container">
    <!-- Search Field -->
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>{{ 'VEHICLE_MANAGEMENT.SEARCH_VEHICLES' | transloco }}</mat-label>
      <input matInput [placeholder]="'VEHICLE_MANAGEMENT.SEARCH_PLACEHOLDER' | transloco" [(ngModel)]="searchQuery"
        (input)="filterVehicles()">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <!-- Gate Filter Dropdown -->
    <div class="gate-filter-container">
      <button mat-stroked-button [matMenuTriggerFor]="gateMenu" class="gate-filter-button">
        <mat-icon>filter_alt</mat-icon>
        {{ 'VEHICLE_MANAGEMENT.FILTER_BY_GATE' | transloco }}
        @if (selectedGateIds.length > 0) {
          <span class="badge">{{ selectedGateIds.length }}</span>
        }
        <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
      </button>
      <mat-menu #gateMenu="matMenu" class="gate-menu">
        <div class="menu-header">
          <span class="menu-title">{{ 'VEHICLE_MANAGEMENT.FILTER_BY_GATE' | transloco }}</span>
          <button mat-icon-button (click)="$event.stopPropagation(); clearFilters()" class="clear-btn"
            [disabled]="selectedGateIds.length === 0">
            <mat-icon>clear_all</mat-icon>
          </button>
        </div>
        <mat-selection-list #gatesList>
          <!-- No Gate option -->
          <mat-list-option [selected]="isGateSelected('no-gate')"
            (click)="toggleGateSelection('no-gate'); $event.stopPropagation()">
            <span class="gate-name">{{ 'VEHICLE_MANAGEMENT.NO_GATE' | transloco }}</span>
          </mat-list-option>

          <!-- Divider -->
          <mat-divider></mat-divider>

          <!-- Regular gate options -->
          @for (gate of gates; track gate) {
            <mat-list-option [selected]="isGateSelected(gate.id)"
              (click)="toggleGateSelection(gate.id); $event.stopPropagation()">
              <span class="gate-name">{{ gate?.description }}</span>
            </mat-list-option>
          }
        </mat-selection-list>
      </mat-menu>
    </div>

    <!-- Clear Filters Button -->
    @if (searchQuery || selectedGateIds.length > 0) {
      <button mat-stroked-button color="warn" class="clear-filters"
        (click)="clearFilters()">
        <mat-icon>clear_all</mat-icon>
        {{ 'FORM.CLEAR' | transloco }}
      </button>
    }
  </div>

  <!-- Vehicle List -->
  @if (filteredVehicles?.length) {
    <div class="vehicle-grid">
      @for (vehicle of filteredVehicles; track vehicle) {
        <mat-card class="vehicle-card">
          <mat-card-header class="vehicle-header">
            <mat-icon mat-card-avatar class="vehicle-icon">directions_car</mat-icon>
            <mat-card-title class="vehicle-title">{{vehicle.regNo | uppercase}}</mat-card-title>
            <mat-card-subtitle class="vehicle-subtitle">
              {{ 'VEHICLE_MANAGEMENT.GATES_ASSIGNED' | transloco: { count: vehicle.gates?.length || 0 } }}
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content class="vehicle-content">
            @if (vehicle.gates?.length) {
              <div class="gates-list">
                <mat-chip-listbox class="chip-list-container">
                  @for (gate of vehicle.gates; track gate) {
                    <mat-chip [title]="$safeNavigationMigration(getGateDetailsById(gate)?.description)" class="gate-chip">
                      {{ getGateDetailsById(gate)?.description || ('VEHICLE_MANAGEMENT.UNKNOWN_GATE' | transloco) }}
                    </mat-chip>
                  }
                </mat-chip-listbox>
              </div>
            } @else {
              <div class="no-gates">
                <mat-icon class="warning-icon">warning</mat-icon>
                <span>{{ 'VEHICLE_MANAGEMENT.NO_GATES_ASSIGNED' | transloco }}</span>
              </div>
            }
            @if (vehicle.comment) {
              <div class="vehicle-comments">
                <mat-icon class="comment-icon">comment</mat-icon>
                <p class="comment-text">{{ vehicle.comment }}</p>
              </div>
            }
          </mat-card-content>
          <mat-card-actions align="end" class="px-3 pb-3">
            <button mat-button color="warn" (click)="$event.stopPropagation(); deleteVehicle(vehicle)" class="delete-button">
              <mat-icon>delete</mat-icon>
              {{ 'FORM.DELETE' | transloco }}
            </button>
            <button mat-button color="primary" (click)="$event.stopPropagation(); editVehicle(vehicle)">
              <mat-icon>edit</mat-icon>
              {{ 'FORM.EDIT' | transloco }}
            </button>
          </mat-card-actions>
        </mat-card>
      }
    </div>
  }

  <!-- Empty State -->
  @if (!filteredVehicles?.length) {
    <div class="empty-state">
      <mat-icon class="empty-icon">directions_car</mat-icon>
      <h3>{{ (searchQuery ? 'VEHICLE_MANAGEMENT.NO_MATCHING_VEHICLES' : 'VEHICLE_MANAGEMENT.NO_VEHICLES_AVAILABLE') |
      transloco }}</h3>
      @if (!searchQuery) {
        <p>{{ 'VEHICLE_MANAGEMENT.ADD_VEHICLE_TO_START' | transloco }}</p>
      }
      @if (searchQuery) {
        <p>{{ 'VEHICLE_MANAGEMENT.ADJUST_SEARCH' | transloco }}</p>
      }
    </div>
  }
</div>
